import json from '../assets/pincodes_minified.json'
const PinCodeService = {
    data: {
        pincodeData: json
    },
    methods:
    {
        getStateName(pincode) {
            try {
                const result = PinCodeService.data.pincodeData.filter(m => m.Pincode === pincode);
                return result[0].StateName
            }
            catch (err) {
                console.log('State Name not found!')
            }

        }
    }
}
export default PinCodeService